module.exports = __webpack_public_path__ + "static/media/csk-desktop-1220x150-80.72b5ec6a.webp";